export default "__VITE_ASSET__SZ22I1mM__"